import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LocationsHero from './components/LocationsHero';
import TrustBar from '../home/components/TrustBar';
import LocationBlocksSection from './components/LocationBlocksSection';
import WhyChooseUs from '../home/components/WhyChooseUs';
import ProcessSection from '../home/components/ProcessSection';
import AboutSection from '../home/components/AboutSection';
import TestimonialsSection from '../home/components/TestimonialsSection';
import ServiceAreasSection from '../home/components/ServiceAreasSection';
import SpecialOfferSection from '../home/components/SpecialOfferSection';
import LocationsFAQSection from './components/LocationsFAQSection';
import CTASection from '../home/components/CTASection';
import GallerySection from '../home/components/GallerySection';

const LocationsPage = () => {
  useEffect(() => {
    document.title =
      'Custom Tailoring Near Me | Massachusetts Service Areas | Custom Clothiers Wellesley MA';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <LocationsHero />
        <TrustBar />
        <LocationBlocksSection />
        <WhyChooseUs />
        <ProcessSection />
        <AboutSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <SpecialOfferSection />
        <LocationsFAQSection />
        <CTASection />
        <GallerySection />
      </main>
      <Footer />
    </div>
  );
};

export default LocationsPage;
